import { get, post, put, patch, del } from 'aws-amplify/api';
import { isCdkProxyConfigured } from './appConfig';
import { fetchCdkApi } from './cdkProxy';

const AMPLIFY = {
  get,
  post,
  put,
  patch,
  delete: del,
};

/**
 * Rutas nativas de NuaTalker (`/me`, `/users`, `/roles`, `/platform`,
 * `/products`). Con `REACT_APP_NUA_PROXY_URL` van al CDK. Si no, Amplify.
 */
export async function callNuatalker({
  path,
  method = 'GET',
  body,
  queryParams,
  callApi,
}) {
  if (isCdkProxyConfigured()) {
    return fetchCdkApi({ path, method, body, queryParams });
  }

  if (callApi) {
    return callApi({
      apiName: 'nuatalker',
      path,
      method: String(method).toLowerCase(),
      body,
      queryParams,
    });
  }

  const apiMethod = AMPLIFY[String(method).toLowerCase()];
  if (!apiMethod) throw new Error(`Método no soportado: ${method}`);

  const methodLower = String(method).toLowerCase();
  const options = {
    ...(queryParams ? { queryParams } : {}),
    ...(['post', 'put', 'patch'].includes(methodLower) && body !== undefined
      ? { body }
      : {}),
  };
  const { body: bodyResponse } = await apiMethod({
    apiName: 'nuatalker',
    path,
    options,
  }).response;
  try {
    return await bodyResponse.json();
  } catch {
    return null;
  }
}
